import React from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Scheda08 = () => {

  return (<>
    <PageHeader
    title="Scheda 08"
    description="CRITERI IDENTIFICAZIONE RISCHI E MITIGAZIONI"
    className="mb-3"
    >
    </PageHeader>
    
    <Card style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Text>
            <p>Per dare sistematicità alla <strong>identificazione IRO</strong> (Impatti, Rischi e Opportunità) si è fatto riferimento ai principi ESRS (European Sustainability Reporting Standards) da cui derivano le norme CRSD, con i seguenti CRITERI:</p>
            <br/>
            <p><strong>IDENTIFICAZIONE DEI RISCHI</strong></p>

            <p>classifica degli ambiti per DIMENSIONE DELLA SOSTENIBILITA’ (AMBIENTALE, SOCIALE, GOVERNANCE) e per TIPO DI IMPATTO (INSIDE OUT) O FINANZIARIO (OUTSIDE IN), dove:</p>
            <ul>
              <li>
              <strong>IMPATTO (INSIDE OUT)</strong>: riguarda gli effetti rilevanti della azienda, negativi o positivi, effettivi o potenziali, sulle persone o {`sull'ambiente`}, connessi alle operazioni proprie della azienda ed alla catena del valore a monte ed a valle, anche attraverso i suoi prodotti e servizi ed i suoi rapporti commerciali.
              </li><br/>
              <li>
              <strong>FINANZIARIO (OUTSIDE IN)</strong>: riguarda i condizionamenti della azienda conseguenti alle sue dipendenze dalla disponibilità di risorse naturali o sociali a prezzi adeguati e di qualità idonea, indipendentemente dagli impatti potenziali che l’azienda potrebbe avere su tali risorse.
              </li>
            </ul>


<p>Disponibilità di <strong>66 esemplificazioni</strong> per ogni ambito e tipo di impatto (33 ambiti x 2 = impatto e Finanziario)</p><br/>

<p><strong>IDENTIFICAZIONE DELLE MITIGAZIONI DEI RISCHI</strong> tramite AZIONI relative al perseguimento di:</p>
<ul>
  <li>
    OPPORTUNITA’ d’IMPATTO per gli STAKEHOLDER COMUNI e l’AZIENDA per KPI, con relativi COSTI e CONTRIBUTI eventuali 
  </li>
  <li>
  OPPORTUNITA’ FINANZIARIE per gli STAKEHOLDER FRUITORI e l’AZIENDA per KPI, con relativi COSTI e CONTRIBUTI eventuali 
  </li>
</ul>

<p>Disponibilità esemplificazioni per identificazione di 77 KPI per le azioni e 308 per le metriche di mitigazione = 77 KPI per 4 metriche d’impatto, con n.77 opportunità per stakeholder e n. 231 opportunità, costi e contributi per l’azienda</p>
<p>La descrizione dei RISCHI e delle loro MITIGAZIONI secondo i CRITERI precedenti relativi agli stakeholder/ambiti prima selezionati possono essere riprese da quelle proposte nelle esemplificazioni prima evidenziate oppure sostituite da altre ritenute maggiormente significative o per le quali siano disponibili migliori informazioni qualitative e specialmente quantitative per la TERZA FASE di valutazione aziendale degli impatti e finanziari</p>
<p>La individuazione dei RISCHI e dei KPI specifici di MITIGAZIONE dei RISCHI d’IMPATTO e FINANZIARI:</p>
<ul>
  <li>
    terrà conto delle tipologie A, B, C di tali ambiti evidenziate in precedenza,  
  </li>
  <li>
    utilizzerà uno SCHEMA UNIFICATO di rilevazione INPUT per la parte delle IDENTIFICAZIONI RISCHI/MITIGAZIONI – evidenziata in azzurro – V. ALL. 9)
  </li>

</ul><br/>

<p><strong>MODALITA' DI EVENTUALE SOSTITUZIONE DELLE ESEMPLIFICAZIONI</strong></p>

<p>Le esemplificazioni della metodologia CSVC sono preimpostate nei singoli ambiti.</p>

<p>È possibile sostituire i RISCHI e le loro MITIGAZIONI preimpostati con altri ritenuti maggiormente significativi o per i quali siano disponibili migliori informazioni qualitative e sopratutto quantitative.</p>

<p>Per sostituire i rischi esistenti <strong>andare nella scheda dell'ambito</strong>, cliccare sul pulsante <strong>[ Ridefinisci il rischio ]</strong> e seguire le istruzioni.</p>

<p>Il <strong>primo passaggio</strong> consiste nell'eliminare il rischio già presente nel questionario. Tale eliminazione comporterà anche l'eliminazione di tutti i dati correlati eventualmente già inseriti.</p>

<p>Il <strong>secondo passaggio</strong> consisterà nel definire il nuovo rischio.</p>

<p>Verrà richiesto l'inserimento di:</p>

<ul>
  <li>Definizione del rischio</li>
  <li>Identificazione dello stakeholder impattato</li>
  <li>Numero di azioni di mitigazione da inserire (1 o 2)</li>
</ul>

<p>per ciascuna azione che si vuole inserire:</p>

<ul>
  <li>Definizione dell'azione di mitigazione</li>
  <li>Definizione dell'opportunità per lo stakeholder</li>
  <li>Definizione dell'opportunità per l'azienda</li>
  <li>Conto su cui inserire l'opportunità economica per l'azienda</li>
  <li>Conto su cui inserire i costi</li>
  <li>Conto su cui inserire eventuali contributi</li>
</ul>

          </Card.Text>
          <Card.Footer>
              <Link to="/app/metodologia/fase-b">
                <FontAwesomeIcon icon="chevron-left" className="ms-1 fs-11" />&nbsp;&nbsp;&nbsp;
                Torna all'elenco delle schede della fase B EFRAG 
              </Link>
           </Card.Footer>
        </Card.Body>
      </Card>

    </>)
};

export default Scheda08;
